import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';
import utility from '../../util/utilityfunctions';
import { HttpStatusCodes } from '../../util/uiconstants';

export default function docHelperDocumentsReducer(state = initialstate.docHelperDocuments, action) {
	switch (action.type) {
		case 'KRONOS_DOCUMENT_DOWNLOAD_PROGRESS':
		case 'KRONOS_DOCUMENT_DOWNLOAD_COMPLETE':
		case 'KRONOS_DOCUMENT_UPLOAD_PROGRESS':
		case 'KRONOS_DOCUMENT_UPLOAD_COMPLETE': {
			// Scenario: Documents Edit, Save and Close
			// This scenario will have actions dispatched from documentHub directly
			// It will not come from docHelperMiddleware, So the payload will be missing
			// For these scenarios we should handle only the progress bar.

			const getProgressState = (docId, inProgress, progressPct, totalPct) => {
				return {
					documentId: docId,
					inProgress: inProgress,
					progressPercent: progressPct,
					totalPercentage: totalPct
				};
			};

			if (!action.meta.docHelper) {
				let fileName = action.meta.message && action.meta.message.FileName;
				let itemKey = fileName + '_' + action.meta.message.FileId;
				if (action.type === 'KRONOS_DOCUMENT_UPLOAD_COMPLETE') {
					const code = action?.meta?.code;
					const document = action?.meta?.document;
					if (code === HttpStatusCodes.Conflict) {
						const key = document?.Name + '_' + document?.Id;
						return {
							...state,
							[key]: getProgressState(document?.Id, false, 100, 100)
						};
					}
					return _.omit(state, itemKey);
				}
				let roundedPercent = Math.min(Math.round(action.meta.message.ProgressPercent), 99);
				let updatedState = getProgressState(action.meta.message.FileId, true, roundedPercent, 100);
				return Object.assign({}, state, {
					[itemKey]: updatedState
				});
			}

			//get document from state and update only progress
			// For Progress and Complete only update the progress
			let docObjFromAction = action.meta.docHelper;

			let message = docObjFromAction.message;

			let updatedDocHelperState = {...state};
			if (!message) {
				return updatedDocHelperState;
			}
			let keyToSearch = message.FileName;
			if (action.type === 'KRONOS_DOCUMENT_DOWNLOAD_COMPLETE' || action.type === 'KRONOS_DOCUMENT_DOWNLOAD_PROGRESS') {
				// search key start with message.FileName + "_" + message.FileId in docHelperState
				keyToSearch = message.FileName + '_' + message.FileId;
			}
			let updatedDocHelperStateKeys = utility.GetDocHelperStateKey(state, keyToSearch);
			updatedDocHelperStateKeys.forEach((key) => {
				if (action.type === 'KRONOS_DOCUMENT_DOWNLOAD_COMPLETE') {
					updatedDocHelperState = _.omit(updatedDocHelperState, key);
				} else {
					let docObjectFromState = state[key];
					let roundedPct = Math.min(Math.round(message.ProgressPercent), 99);
					let inProgress = docObjFromAction && docObjFromAction.payload && docObjFromAction.payload.inProgress;
					let updatedState = {
						...docObjectFromState,
						documentId: message.FileId,
						inProgress: inProgress ? inProgress : roundedPct < 100,
						progressPercent: roundedPct,
						totalPercentage: 100
					};
					Object.assign(updatedDocHelperState, updatedDocHelperState, {
						[key]: updatedState
					});
				}
			});

			return updatedDocHelperState;
		}
		case 'KRONOS_DOCHELPER_DOWNLOAD_DOCUMENT': {
			if (action.meta && action.meta.docHelper && action.meta.docHelper.payload) {
				let docKey = action.meta.docHelper.payload.dockey;
				if (!docKey) {
					docKey = '';
				}
				let downloadDocObj = {
					[action.meta.docHelper.payload.documentName + docKey]: {
						...action.meta.docHelper.payload
					}
				};
				return Object.assign({}, state, downloadDocObj) || {};
			}
			return {};
		}
		case 'KRONOS_DOCHELPER_UPLOAD_DOCUMENT': {
			const payload = action.meta.docHelper.docPayload;
			if (payload) {
				return Object.assign(
					{},
					state,
					...payload.map((item, index) => ({
						[action.responseObj.data[index].name]: {...item}
					}))
				);
			}
			return state;
		}
		case 'DOCHELPER_ERROR': {
			const result = {...state};
			delete result[action.error[1]];
			return result;
		}
		case 'DOCUMENT_UPLOAD_ERROR':
			console.log('document upload error', action);
			//TODO: Handle Upload Error scenario
			break;
		case 'ASSOCIATE_TASK_DOCUMENTS':
		case types.REMOVE_TASK_DOCUMENT:
			return _.omit(state, action.documentName);
		case types.KRONOS_DOCHELPER_UPLOAD_COMPLETE: {
			if (action.meta && action.meta.fileName) {
				return _.omit(state, action.meta.fileName);
			}
			return state;
		}
		default:
			return state;
	}
}
